<script src="../../../store/module/userOnline.js"></script>
<template>
    <div>
        <div>
            <el-button type="danger" @click="removeItem(selection)">删除</el-button>

            <div class="common-search">
                <el-input
                        v-model="searchVal"
                        class="common-el-input"
                        @keyup.enter="getList()"
                        placeholder="请输入玩家ID或昵称进行查询">
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
                <el-button type="primary" @click="getList()">搜索</el-button>
            </div>
        </div>

        <div class="common-table">
            <el-table v-loading="loading" :data="createRoomUserList.beanList" row-key="randomId" height="100%"
                      @selection-change="selectionChange">
                <el-table-column type="selection" width="55"/>
                <el-table-column label="编号" type="index" align="center"/>
                <el-table-column label="用户ID" min-width="120" align="center" prop="randomId"/>
                <el-table-column label="用户昵称" min-width="150" align="center" prop="nickName"/>
                <el-table-column label="俱乐部" min-width="180" align="center" prop="clubName"/>
                <el-table-column label="可提/不可提/金豆数" min-width="250" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.canExtractChip*0.01}}/{{scope.row.notExtractChip*0.01}}/{{scope.row.chip*0.01}}
                    </template>
                </el-table-column>
                <el-table-column label="账户状态" align="center" prop="statu">
                    <template slot-scope="scope">{{scope.row.statu?'启用':'冻结'}}</template>
                </el-table-column>
                <el-table-column label="玩家身份" align="center" prop="userType">
                    <template slot-scope="scope">{{scope.row.userType | userTypeName}}</template>
                </el-table-column>
                <el-table-column label="联系方式" min-width="150" align="center" prop="phone"/>
                <el-table-column label="操作" align="center" width="150">
                    <template slot-scope="scope">
                        <el-button type="danger" size="mini" @click="removeItem([scope.row.randomId])">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination
                class="common-el-pagination"
                layout="prev,pager,next,jumper"
                background
                :page-size="20"
                :pager-count="5"
                :total="createRoomUserList.total"
                :current-page="currentPage"
                @current-change="getList($event)"/>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
            return {
                loading: false,
                searchVal: '',
                selection: [],
                currentPage: 1,
            }
        },
        computed: {
            ...mapState('user', ['createRoomUserList'])
        },
        created() {
            this.getList()
        },
        methods: {
            ...mapActions('user', ['getCreateRoomUserList', 'closeCreateRoomOp']),
            getList(page = 1) {
                this.loading = true;
                this.currentPage = page;
                this.getCreateRoomUserList({
                    content: this.searchVal,
                    page
                }).then(() => {
                    this.loading = false;
                    if(!this.createRoomUserList.beanList.length && page !== 1){
                        this.getList(this.currentPage - 1)
                    }
                });
            },
            selectionChange(rows) {
                this.selection = rows.map(item => {
                    return item.randomId
                })
            },
            removeItem(ids) {
                this.$confirm('您确认要关闭选中玩家的“开房权限功能吗”？', '提示', {
                    type: 'warning'
                }).then(() => {
                    this.closeCreateRoomOp({
                        ids: ids
                    }).then(() => {
                        this.$message.success('删除成功');
                        this.getList(this.currentPage)
                    })
                }).catch(() => {
                });

            }
        }
    }
</script>

